import { FilterIconComponent } from '../component/FilterIconComponent/FilterIconComponent';

export const FilterIcon = (isFiltered: boolean) => (
  <FilterIconComponent isFiltered={isFiltered} />
);
